import { APP_CONTEXTS, IRootState } from "app/model"
import { CAMPAIGN_STATUSES } from "campaign/model"
import { FORM_SAVE_ERRORS, IForm, IFormError } from "form/model"
import { createPageFormEffect } from "form/tools/page"
import React from "react"
import { connect } from "react-redux"
import { FormLayout } from "./layout/FormLayout"

interface ICreateDspDealPageProps {
  context: APP_CONTEXTS | null
  isLoadingInitialData: boolean
  hasInitialDataLoadingError: boolean
  isLoading: boolean
  error: IFormError
  saveError: FORM_SAVE_ERRORS | null
  status: CAMPAIGN_STATUSES | null
  form: IForm
}

const CreateDspDealPageFn = React.memo(
  ({
    context,
    isLoadingInitialData,
    hasInitialDataLoadingError,
    isLoading,
    error,
    saveError,
    status,
    form
  }: ICreateDspDealPageProps) => {
    const isFirstRenderWithContext = React.useRef(true)
    React.useEffect(
      () => createPageFormEffect(form, context, APP_CONTEXTS.DSP_DEAL_CREATE, isFirstRenderWithContext),
      [context]
    )
    if (!context) {
      return null
    }
    return (
      <FormLayout
        form={form}
        status={status}
        hasInitialDataLoadingError={hasInitialDataLoadingError}
        isLoadingInitialData={isLoadingInitialData}
        isLoading={isLoading}
        error={error}
        saveError={saveError}
      />
    )
  }
)

export const CreateDspDealPage = connect(
  (state: IRootState): ICreateDspDealPageProps => ({
    context: state.app.activeContext,
    isLoadingInitialData: state.app.isInitializating,
    hasInitialDataLoadingError: state.app.hasInitError,
    isLoading: state.form.dspDealCreateForm.isLoading,
    error: state.form.dspDealCreateForm.error,
    status: state.form.dspDealCreateForm.form.statusId,
    form: state.form.dspDealCreateForm.form,
    saveError: state.form.dspDealCreateForm.form.context.saveError
  })
)(CreateDspDealPageFn)
